export default __webpack_public_path__ + "2422a692e1c172f59c624e2c8be4c63b.jpg";